import { Grid, Typography, IconButton, Paper, Chip } from "@material-ui/core";
import { Add, GetApp } from "@material-ui/icons";
import React from "react";
import UsersGroupTable from "./UsersGroupTable";
import { useHistory, useRouteMatch } from "react-router";
const UsersGroup = () => {
  const history = useHistory();
  const { path } = useRouteMatch();
  return (
    <Paper style={{ width: "100%" }}>
      <Grid item container xs={12} spacing={2} style={{ margin: "auto" }}>
        <Grid
          item
          container
          xs={12}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={6} direction="row" container>
            <Typography style={{ marginLeft: "10px" }} variant="body1">
              گروه کاربران
            </Typography>
            <Chip
              label={2}
              color="primary"
              style={{ width: "50px", fontSize: "15px" }}
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid item>
            <IconButton
              color="primary"
              onClick={() => {
                history.push(`${path}/new-group`);
              }}
            >
              <Add />
            </IconButton>
            <IconButton color="primary">
              <GetApp />
            </IconButton>
          </Grid>
        </Grid>
        {/* users Group table Section */}
        <UsersGroupTable />
      </Grid>
    </Paper>
  );
};

export default UsersGroup;
